/** Supplier price lists in the console (atlante v2, ch. 435, 28/10/2026). Twin of `it.ts`. */
export default {
  pagina: {
    titolo: 'Supplier price lists',
    descrizione: 'Each supplier’s price list, checked every morning from its source. A new version stays a draft until you publish it; quotes never change on their own: each administrator chooses when to use it.',
    ricarica: 'Reload',
    caricamento: 'Reading the price lists…',
    errore: 'The price lists did not load: {{motivo}}',
    nessuno: 'No supplier has a versioned price list yet. Create one with scripts/listini/crea-versione-1-listino-fornitore.cjs.',
  },
  fornitore: {
    in_vigore: 'Version {{numero}} in force',
    del_listino: 'price list of {{data}}',
    controlla: 'Check now',
    controllo_in_corso: 'Checking the source…',
    fonte: 'Source',
    fonte_drive: '“{{file}}” in the public Google Drive folder',
    apri_cartella: 'Open the folder',
    senza_fonte: 'No source: versions are prepared by hand with the script.',
    ultimo_controllo: 'Last check',
    mai_controllato: 'never',
    problema: 'Problem at the last check: {{motivo}}',
    file_non_trovato: 'the file is no longer in the folder (renamed or removed by the supplier)',
  },
  esiti_controllo: {
    invariato: 'The file is the same as at the last check: nothing new.',
    bozza: 'The price list has changed: the draft of version {{numero}} is ready.',
    file_non_trovato: 'The price list file is no longer in the folder.',
    senza_fonte: 'This supplier has no source to check.',
    errore: 'The check failed: {{motivo}}',
  },
  bozza: {
    titolo: 'Draft of version {{numero}}',
    preparata: 'Prepared on {{quando}} from the price list of {{data}}',
    preparata_senza_data: 'Prepared on {{quando}}',
    apri_pdf: 'Open the supplier’s PDF',
    nessuna: 'No draft to publish.',
    sezioni: {
      cambiano: 'Price changes',
      escono: 'Leaving the price list',
      da_verificare: 'To check',
    },
    colonne: {
      codice: 'Code',
      prima: 'Before',
      dopo: 'After',
      differenza: 'Change',
      motivo: 'Why',
      nel_listino: 'In the new price list',
    },
    vuota: {
      cambiano: 'No price changes.',
      escono: 'No product leaves the price list.',
      da_verificare: 'Nothing to check.',
    },
    spiega_escono: 'They keep the previous price and the notice “no longer in the supplier’s price list” until the supplier confirms.',
    spiega_verifica: 'The price is not changed: it stays as before until the supplier clarifies.',
    motivi: {
      codice: 'may have changed code',
      piu_prezzi: 'several prices for the same code',
      soglia: 'changes more than the threshold',
    },
  },
  conteggi: {
    salgono_one: '{{count}} goes up',
    salgono_other: '{{count}} go up',
    scendono_one: '{{count}} goes down',
    scendono_other: '{{count}} go down',
    invariati_one: '{{count}} unchanged',
    invariati_other: '{{count}} unchanged',
    escono_one: '{{count}} leaves',
    escono_other: '{{count}} leave',
    da_verificare_one: '{{count}} to check',
    da_verificare_other: '{{count}} to check',
    nuovi_one: '{{count}} starting price',
    nuovi_other: '{{count}} starting prices',
  },
  pubblica: {
    avvisa: 'Notify the administrators of the client companies',
    avvisa_spiega: 'They get the notice in the bell and by email, and choose when to use the new prices.',
    bottone: 'Publish version {{numero}}',
    conferma_titolo: 'Publish version {{numero}}?',
    conferma_prezzi_one: '{{count}} product takes the new price in the supplier’s catalogue.',
    conferma_prezzi_other: '{{count}} products take the new price in the supplier’s catalogue.',
    conferma_escono_one: '{{count}} product gets the notice “no longer in the price list”.',
    conferma_escono_other: '{{count}} products get the notice “no longer in the price list”.',
    conferma_preventivi: 'No quote changes: each administrator chooses when to use the version and on which quotes.',
    conferma_avvisi_si: 'The administrators of the client companies get the notice, also by email.',
    conferma_avvisi_no: 'No notice and no email: the version shows on each company’s “Supplier price list” page.',
    annulla: 'Cancel',
    in_corso: 'Publishing…',
    fatto: 'Version {{numero}} published: {{prezzi}} products with the new price, {{escono}} out of the price list.',
    errore: 'The version was not published: {{motivo}}',
  },
  storia: {
    titolo: 'Published versions',
    versione: 'Version {{numero}}',
    origine_catalogo: 'the catalogue prices',
    pubblicata: 'published on {{quando}}',
    con_avvisi: 'with notices',
    senza_avvisi: 'without notices',
  },
} as const;
